import React from 'react';
import { TRI_STATE_OPTIONS, triStateClass, triStateValue } from '../utils/triState';

/**
 * A Yes / No / To be decided field (Harvest, NIT, Germination Test, TGW), coloured by its value.
 * `value` is 0, 1 or 2 (old boolean values are read as 1/0); `onChange(0 | 1 | 2)`. With
 * `unchangedLabel` (mass update) there is also an empty choice, `onChange('')`.
 */
export default function TriStateSelect({ id, name = id, label, value, onChange, unchangedLabel = null, defaultValue = 2 }) {
  const current = triStateValue(value);
  const shown = current ?? (unchangedLabel ? '' : defaultValue);
  return (
    <div className="flex flex-col gap-1">
      {label && <label htmlFor={id} className="text-sm font-medium">{label}</label>}
      <select
        id={id}
        name={name}
        value={String(shown)}
        onChange={(e) => onChange(e.target.value === '' ? '' : Number(e.target.value))}
        className={`text-sm rounded px-2 py-1 border transition-colors dark:bg-gray-800/60 dark:text-white ${shown === '' ? 'bg-white text-gray-700 border-gray-300' : triStateClass(shown)}`}
      >
        {unchangedLabel && <option value="">{unchangedLabel}</option>}
        {TRI_STATE_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>
    </div>
  );
}
